import { IBaseModel } from '../base/base-model.interface';
import { IOdb } from '../odbs/odb.interface';
import {
  createEnumOptions,
  createEnumOptionsBoolean,
} from '../shared/enum-option.interface';

export enum AccessPointConnectable {
  NO = 0,
  MAYBE = 1,
  YES = 2,
}

export enum AccessPointServiceProvider {
  NONE = 0,
  YOU = 1,
  OTHER = 2,
}

export enum DopType {
  aerial = 'aerial',
  underground = 'underground',
  combined = 'combined',
  flat = 'flat',
}

export enum EndpointType {
  drop = 'drop',
  socket = 'socket',
}

export enum BuildingType {
  type1 = 1,
  type2 = 2,
  type3 = 3,
  type4 = 4,
  type5 = 5,
  type6 = 6,
  type7 = 7,
  type8 = 8,
  houseOfFlats = 9,
  type10 = 10,
  type11 = 11,
  type12 = 12,
  type13 = 13,
  type14 = 14,
  type15 = 15,
  type16 = 16,
  type17 = 17,
  type18 = 18,
  type19 = 19,
  type20 = 20,
  type21 = 21,
  type22 = 22,
  type23 = 23,
}

export enum ConstructionStatus {
  underConstruction = 'underConstruction',
  complete = 'complete',
  readyForSale = 'readyForSale',
}

export enum AccessPointActions {
  delete = 'delete',
}

export const accessPointMassActionOptions = createEnumOptions({
  [AccessPointActions.delete]: { label: 'Vymazať' },
  _default: { label: '-' },
});

export interface IAccessPointMassActionData {
  action: AccessPointActions;
}

export const connectableOptions = createEnumOptions<AccessPointConnectable>({
  [AccessPointConnectable.YES]: {
    label: 'Pokrytie - Pripojiteľné',
    color: 'success',
  },
  [AccessPointConnectable.NO]: {
    label: 'Pokrytie - Nepripojiteľné',
    color: 'danger',
  },
  [AccessPointConnectable.MAYBE]: {
    label: 'Pokrytie - Pripojiteľné na overenie',
    color: 'warn',
  },
  _default: {
    label: '-',
    color: 'none',
  },
});

export const serviceProviderOptions =
  createEnumOptions<AccessPointServiceProvider>({
    [AccessPointServiceProvider.NONE]: {
      label: 'Voľné',
      color: 'success',
    },
    [AccessPointServiceProvider.OTHER]: {
      label: 'Obsadené iným ISP',
      color: 'warn',
    },
    [AccessPointServiceProvider.YOU]: {
      label: 'Obsadené prihláseným ISP',
      color: 'warn',
    },
    _default: {
      label: '-',
      color: 'none',
    },
  });

export const connectedStatusOptions = createEnumOptionsBoolean({
  true: {
    label: 'DOP vybudovaná',
    color: 'success',
  },
  false: {
    label: 'DOP nevybudovaná',
    color: 'warn',
  },
});
export const dopTypeOptions = createEnumOptions<DopType>({
  [DopType.aerial]: { label: 'Vzduchom' },
  [DopType.underground]: { label: 'Zemou' },
  [DopType.combined]: { label: 'Kombinácia' },
  [DopType.flat]: { label: 'Bytovka' },
  _default: { label: '-' },
});

export const endpointTypeOptions = createEnumOptions<EndpointType>({
  [EndpointType.drop]: { label: 'Drop kábel' },
  [EndpointType.socket]: { label: 'Optická zásuvka' },
  _default: { label: '-' },
});

export const buildingTypeOptions = createEnumOptions<BuildingType>({
  [BuildingType.type1]: { label: 'Priemyselná budova' },
  [BuildingType.type2]: {
    label: 'Poľnohospodárska budova',
  },
  [BuildingType.type3]: { label: 'Budova železníc a dráh' },
  [BuildingType.type4]: {
    label: 'Budova pre správu a údržbu diaľnic a rýchlostných ciest',
  },
  [BuildingType.type5]: { label: 'Budova letísk' },
  [BuildingType.type6]: {
    label:
      'Iná dopravná a telekomunikačná budova (budova prístavu, garáže, kryté parkovisko, budova na rádiové a televízne vysielanie a iné)',
  },
  [BuildingType.type7]: {
    label: 'Samostatne stojaca garáž',
  },
  [BuildingType.type8]: {
    label:
      'Budova lesného hospodárstva (horáreň, technická prevádzková stavba a iné)',
  },
  [BuildingType.houseOfFlats]: { label: 'Bytový dom' },
  [BuildingType.type10]: { label: 'Rodinný dom' },
  [BuildingType.type11]: {
    label: 'Budova pre školstvo, na vzdelávanie a výskum',
  },
  [BuildingType.type12]: {
    label: 'Budova zdravotníckeho a sociálneho zariadenia',
  },
  [BuildingType.type13]: {
    label: 'Budova ubytovacieho zariadenia',
  },
  [BuildingType.type14]: {
    label: 'Budova obchodu a služieb',
  },
  [BuildingType.type15]: { label: 'Administratívna budova' },
  [BuildingType.type16]: {
    label:
      'Budova pre kultúru a na verejnú zábavu (múzeum, knižnica a galéria)',
  },
  [BuildingType.type17]: {
    label:
      'Budova na vykonávanie náboženských aktivít, krematóriá a domy smútku',
  },
  [BuildingType.type18]: {
    label:
      'Budova technickej vybavenosti sídla (výmenníková stanica, budova na rozvod energií, čerpacia a prečerpávacia stanica, úpravňa vody, transformačná stanica a rozvodňa, budova vodojemu alebo čistiarne odpadových vôd a iné)',
  },
  [BuildingType.type19]: {
    label: 'Budova pre šport a na rekreačné účely',
  },
  [BuildingType.type20]: { label: 'Iná budova' },
  [BuildingType.type21]: { label: 'Rozostavaná budova' },
  [BuildingType.type22]: { label: 'Polyfunkčná budova' },
  [BuildingType.type23]: { label: 'Inžinierska stavba ' },
  _default: { label: '-' },
});

export const constructionStatusOptions = createEnumOptions<ConstructionStatus>({
  [ConstructionStatus.underConstruction]: {
    label: 'Vo výstavbe',
  },
  [ConstructionStatus.complete]: {
    label: 'Dokončená',
  },
  [ConstructionStatus.readyForSale]: {
    label: 'Hotová na predaj',
  },
  _default: { label: '-' },
});

export interface ILocationBounds {
  minGpsX: number;
  minGpsY: number;
  maxGpsX: number;
  maxGpsY: number;
}

export function checkBoundsInTile(
  x: number,
  y: number,
  z: number,
  bounds: ILocationBounds,
) {
  const n = 2 ** z;

  const getTileX = (x: number) => (x / n) * 360 - 180;
  const getTileY = (y: number) =>
    (Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n))) * 180) / Math.PI;

  const tileBoundsGps = {
    minGpsX: getTileX(x),
    maxGpsX: getTileX(x + 1),
    minGpsY: getTileY(y + 1),
    maxGpsY: getTileY(y),
  };

  return (
    tileBoundsGps.minGpsX <= bounds.maxGpsX &&
    tileBoundsGps.maxGpsX >= bounds.minGpsX &&
    tileBoundsGps.minGpsY <= bounds.maxGpsY &&
    tileBoundsGps.maxGpsY >= bounds.minGpsY
  );
}

export interface IAccessPoint extends IBaseModel<'AccessPoint'> {
  id: string;
  eic?: string;
  locId?: string;
  ssdLocId?: string;
  locationHash?: string;
  region?: string;
  county?: string;
  city?: string;
  district?: string;
  street?: string;
  zip?: string;
  parcel?: string;
  houseNumber?: string;
  houseNumberLocal?: string;
  floor?: number;
  flat?: number;
  gpsX?: number;
  gpsY?: number;
  connectableEst?: Date;
  connectableReal?: Date;
  pbId?: string;
  pbGpsX?: number;
  pbGpsY?: number;
  pbDist?: number;
  fttxId?: string;
  fttxDist?: number;
  odb?: IOdb;
  cableLength?: number;
  endpointType?: EndpointType;
  connectable?: AccessPointConnectable;
  connected?: boolean;
  connectedAt?: Date;
  serviceProvider?: string;
  odpProvider?: string;
  oltName?: string;
  ontSn?: string;
  primmarySplitter?: string;
  primmarySplitterGpsX?: number;
  primmarySplitterGpsY?: number;
  odpDate?: Date;
  address?: string;
  serviceProviderStatus: AccessPointServiceProvider;
  connectedStatus: boolean;
  readonly canOrder: boolean;
  readonly canMigrate: boolean;
  mapImg?: string;
  verticalImg?: string;
  cashback?: boolean;
  cashbackIsp?: string;
  oldOmId?: string;
  oldEic?: string;
  // TECHNICAL DATA
  ontPhoto?: string[];
  dopPhoto?: string[];
  dopRoadPhoto?: string[];
  dopRoadAfterPhoto?: string[];
  dopPonmeterPhoto?: string[];
  odbBeforePhoto?: string[];
  odbAfterPhoto?: string[];
  usedOdb?: string;
  dopPort?: number;
  dopType?: DopType;
  dopRoad?: string;
  dopDbmSignal?: number;
  clusterId?: string;
  rgvlanId?: string;
  isCamera: boolean;
  buildingType: BuildingType;
  raId?: string;
  lastOwnClosedOrderStartDate?: Date;
  isTest?: boolean;
  underConstruction?: boolean;
  constructionStatus?: ConstructionStatus;
  hasIspAccess?: boolean;
  note?: string;
}

export const transparentPixel = Uint8Array.from([
  0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a, 0x00, 0x00, 0x00, 0x0d, 0x49,
  0x48, 0x44, 0x52, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x08, 0x06,
  0x00, 0x00, 0x00, 0x1f, 0x15, 0xc4, 0x89, 0x00, 0x00, 0x00, 0x0a, 0x49, 0x44,
  0x41, 0x54, 0x78, 0x9c, 0x63, 0x00, 0x01, 0x00, 0x00, 0x05, 0x00, 0x01, 0x0d,
  0x0a, 0x2d, 0xb4, 0x00, 0x00, 0x00, 0x00, 0x49, 0x45, 0x4e, 0x44, 0xae, 0x42,
  0x60, 0x82,
]);
